import { database } from '@/firebase';

const {
  getDBTime,
  getCollection,
  updateRecord,
  createRecord,
  deleteRecord,
} = database;


const fetchDiscount = code => getCollection({
  model: 'discounts',
  where: [{
    prop: 'code',
    comparison: '==',
    value: code,
  }],
});

export default {
  fetchDiscount(state, code) {
    if (code) {
      return fetchDiscount(code).then(response => response && response[0]);
    }
    return Promise.resolve(null);
  },
  fetchAllDiscounts({ commit }) {
    return getCollection({
      model: 'discounts',
      sort: [{
        prop: 'createdAt',
        direction: 'desc',
      }],
    }).then((response) => {
      commit('set', { model: 'discounts', value: response });
    });
  },
  updateDiscount({ dispatch }, discount) {
    const { id, ...payload } = discount;
    return updateRecord({
      model: 'discounts',
      id,
      value: payload,
    }).then(() => dispatch('fetchAllDiscounts'));
  },
  removeDiscount({ dispatch }, id) {
    return deleteRecord({
      model: 'discounts',
      id,
    }).then(() => dispatch('fetchAllDiscounts'));
  },
  createDiscount({ dispatch }, discount) {
    return createRecord({
      model: 'discounts',
      value: {
        ...discount,
        createdAt: getDBTime(),
      },
    }).then(() => dispatch('fetchAllDiscounts'));
  },
};
